const ADD_DATA_TO_MODAL = 'ADD_DATA_TO_MODAL';

const defaultState = {
    id: '',
    title: '',
    price: '',
    description: '',
    img: '',
    species: '',
    sort: '',
    size: ''
};

export default function modalDataReducer(state = defaultState, action) {
    switch (action.type) {
        case ADD_DATA_TO_MODAL:
            return {
                id: action.payload.id,
                title: action.payload.title,
                price: action.payload.price,
                description: action.payload.description,
                img: action.payload.img,
                species: action.payload.species,
                sort: action.payload.sort,
                size: action.payload.size
            }
        default:
            return state
    }
}